import {
  discoveryApiRef,
  fetchApiRef,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { githubActionsApiRef } from '@backstage-community/plugin-github-actions';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import { GithubActionsProxyClient } from './GithubActionsProxyClient';

const githubActionsProxyApi = githubActionsPlugin
  .getExtension('api:github-actions')
  .override({
    params: defineParams =>
      defineParams({
        api: githubActionsApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new GithubActionsProxyClient({ discoveryApi, fetchApi }),
      }),
  });

const githubActionsPatPlugin: FrontendPlugin =
  githubActionsPlugin.withOverrides({
    extensions: [githubActionsProxyApi],
  });

export default githubActionsPatPlugin;
